














































import Vue from 'vue'
import { Component, Prop, Watch } from 'vue-property-decorator'
import Tab from './Tab.vue'

@Component<Tabs>({})
export default class Tabs extends Vue {
    @Prop(String) public active?: string
    @Prop(Boolean) public canRemoveTabs?: boolean
    // Theme modifiers
    @Prop({type: Boolean, default: false}) public vsmall?: boolean
    @Prop({type: Boolean, default: false}) public small?: boolean
    @Prop({type: Boolean, default: false}) public large?: boolean
    @Prop({type: Boolean, default: false}) public pills?: boolean
    @Prop({type: Array, default: () => []}) public errorIndices!: number[]
    @Prop({type: Boolean, default: false}) public showArrow?: boolean
    @Prop({type: Boolean, default: false}) public breadcrumbs?: boolean
    @Prop({type: Boolean, default: false}) public fullWidth?: boolean
    @Prop({type: Boolean, default: false}) public canRemoveSingleTabs?: boolean

    public tabs: Tab[] = []

    @Watch('active')
    public onActiveChanged(newActive) {
        Vue.nextTick().then(() => {
            this.applyActiveTab(newActive)
        })
    }

    public mounted() {
        this.tabs = this.$children as Tab[]

        if (!this.tabs[0]) {
            throw new Error('No child tabs')
        }
        if (this.active) {
            this.applyActiveTab(this.active)
        }
    }

    public selectTab(tabName: string) {
        this.$emit('change', tabName)
    }

    private removeTab(tabName: string) {
        this.$emit('remove', tabName)
        Vue.nextTick(() => {
            this.applyActiveTab(this.active)
        })
    }

    private applyActiveTab(tabName) {
        this.tabs.forEach((tab) => {
            tab.isActive = tab.name === tabName
        })
    }

    private get showRemoveTab() {
        if (this.canRemoveSingleTabs) {
            return true
        }
        return this.canRemoveTabs && this.tabs.length > 1
    }
}
